import { useEffect, useState } from "react";

function useLatestClick(callback: () => void, delay: number): () => void {
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  const handleClick = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    const newTimeoutId = setTimeout(() => {
      callback();
    }, delay);

    setTimeoutId(newTimeoutId);
  };

  return handleClick;
}

export default useLatestClick;
